<div class="project-users-modal">
    <p-table #dt [value]="projectUserList" [loading]="loading"
        [globalFilterFields]="['firstName','lastName','email','roleName','userTypeName']" [tableStyle]="{'min-width': '50rem'}"
        styleClass="project-users-table">

        <ng-template pTemplate="caption">
            <div class="modal-caption">
                <div class="caption-title-wrap">
                    <span class="caption-title">Project Users</span>
                    <span class="caption-count">{{ projectUserList.length }}</span>
                </div>
                <div class="search-wrap">
                    <i class="ri-search-line"></i>
                    <input pInputText type="text" [(ngModel)]="searchValue"
                        (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Search users..." />
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="firstName">
                    Name <p-sortIcon field="firstName"></p-sortIcon>
                </th>
                <th pSortableColumn="email">
                    Email <p-sortIcon field="email"></p-sortIcon>
                </th>
                <th pSortableColumn="roleName">
                    Role <p-sortIcon field="roleName"></p-sortIcon>
                </th>
                <th pSortableColumn="userTypeName">
                    User Type <p-sortIcon field="userTypeName"></p-sortIcon>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user>
            <tr>
                <td>
                    <div class="name-cell">
                        <span class="name-text">{{ user.firstName }} {{ user.lastName }}</span>
                        @if (user.userId) {
                            <span class="id-text">ID: {{ user.userId }}</span>
                        }
                    </div>
                </td>
                <td>
                    <span class="email-text">{{ user.email }}</span>
                </td>
                <td>
                    <p-tag [value]="user.roleName" severity="info" class="text-sm"></p-tag>
                </td>
                <td>
                    <p-tag [value]="user.userTypeName || 'N/A'" severity="secondary" class="text-sm"></p-tag>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" class="empty-cell">
                    <div class="empty-state">
                        <i class="ri-group-line"></i>
                        <span>No users found</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
